// extracted by mini-css-extract-plugin
module.exports = {"tabImg":"ListB_tabImg__z0UXI"};